export const AssetReferenceTypes = {
  Niri: '15',
  Itr: '17',
};
